import React, { useEffect } from "react";
import { Box } from "@twilio-paste/core/box";
import { styled } from "@twilio-paste/core/styling-library";
import { IntelligentDiscoveryHomeBlock } from "@twiliointernal/e2-commons-shared-definitions";
import NoMessageErrorsPresentHome from "./sub/NoMessageErrorsPresentHome";
import MessageErrorsPresentHome from "./sub/MessageErrorsPresentHome";
import { useWiseOwlContext } from "../../../hooks";
import { CDEExternalPromptButtons } from "@twiliointernal/org-twilio-customer-deliverability-engine-utils";

interface OnboardingProps {
  block: IntelligentDiscoveryHomeBlock;
}

const IntelligentDiscoveryAssistantHomeContainer = styled(Box)`
  [data-paste-element="BLOCK_RENDERER"] {
    margin-bottom: 0px;
  }
`;

const IntelligentDiscoveryAssistantHome: React.FC<OnboardingProps> = ({
  block,
}) => {
  const {
    handlers: { handleStartNewChat },
  } = useWiseOwlContext();
  const {
    values: { failedMessages, undeliveredMessages },
  } = block;

  const areMessagingErrorsPresent =
    failedMessages > 0 || undeliveredMessages > 0;

  useEffect(() => {
    const chatId = sessionStorage.getItem("intelligentAssistantSession");
    // create a new chat when IDA is closed
    if (!chatId) {
      const messageSid = sessionStorage.getItem(
        CDEExternalPromptButtons.TROUBLESHOOT_MESSAGE_SID
      );
      if (messageSid) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        handleStartNewChat({
          input: `Help me troubleshoot the message ${messageSid}`,
        });
      }

      const errorCode = sessionStorage.getItem(
        CDEExternalPromptButtons.TROUBLESHOOT_ERROR_CODE
      );
      if (errorCode) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        handleStartNewChat({
          input: `Help me troubleshoot the error ${errorCode}`,
        });
      }
    }
  }, []);

  return (
    <IntelligentDiscoveryAssistantHomeContainer>
      {areMessagingErrorsPresent ? (
        <MessageErrorsPresentHome block={block} />
      ) : (
        <NoMessageErrorsPresentHome block={block} />
      )}
    </IntelligentDiscoveryAssistantHomeContainer>
  );
};

export default IntelligentDiscoveryAssistantHome;
